<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col lg:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Decide qué lleva cada ruta de entrega. 
                Asigna pedidos/paquetes considerando capacidad, 
                ventanas horarias y prioridades, con apoyo de IA. 
                Úsalo para planear la carga diaria y cumplir tiempos.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Asignación de Carga
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Realiza la asignación en las <b>rutas de entrega</b> en base a las solicitudes de los procesos de
          <b>pedido</b> y <b>cambio de productos</b>.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Quiebre de Inventario</div> -->
          <!--@if(filterForm.value.companyId){
          <app-order-datepicker [initialDate]="selectedOrdersPast" [showFuture]="false"
            (dateChange)="onDatePastSelected($event)"></app-order-datepicker>
          <app-order-datepicker [initialDate]="selectedOrdersFuture" [showFuture]="true"
            (dateChange)="onDateFutureSelected($event)"></app-order-datepicker>
        }-->
            <app-order-datepicker [initialDate]="selectedOrdersPast()" [showFuture]="false"
            [isLoading]="isLoadingOrdersPast()"
            (menuOpen)="getOrdersPast()"
            (dateChange)="onDatePastSelected($event)"></app-order-datepicker>
            <app-order-datepicker [initialDate]="selectedOrdersFuture()" [showFuture]="true"
            [isLoading]="isLoadingOrdersFuture()"
            (menuOpen)="getOrdersFuture()"
            (dateChange)="onDateFutureSelected($event)"></app-order-datepicker>
          </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center gap-3 sm:ml-4 sm:mt-0">
          <!-- Ocultado temporalmente en cortijo-qas: funcionalidad de optimizar ruta.
          <button mat-flat-button color="primary" (click)="openRouteOptimization()"
            matTooltip="Propone el recorrido óptimo por sub-ruta de los pedidos con ruta y viaje más los pedidos sin viaje, con los filtros actuales. No modifica los viajes.">
            <mat-icon svgIcon="heroicons_outline:sparkles"></mat-icon>
            Optimizar rutas
          </button>
          -->

          <!--@if(filterForm.value.companyId){
          <app-button-datepicker [initialDate]="selectedDate" (dateChange)="onDateSelected($event)"
            [title]="'F. Carga'"></app-button-datepicker>
        }-->
            <app-button-datepicker [initialDate]="selectedDate" (dateChange)="onDateSelected($event)"
            [title]="'F. Carga'"></app-button-datepicker>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="flex flex-auto overflow-hidden flex-col">
        <div class="container mt-0 flex-auto flex-col overflow-hidden">
          <div class="top-0 z-10 bg-gray-100 dark:bg-gray-900 h-full overflow-hidden">
            <!-- Contenedor de los tabs -->
            <div class="sticky-tabs-container">
              <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms" mat-stretch-tabs>
                @for (tab of groupTabConfig.tabs; track $index) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="sticky-tab-label">
                      <mat-icon [svgIcon]="tab.icon" [style.color]="tab.color" class="w-6 h-6"></mat-icon>
                      <span [innerHTML]="tab.label"></span>
                      <span matBadge="{{tab.count()}}" matBadgeOverlap="false"></span>
                      @if(tab.map){
                       <mat-icon
                        color='primary'
                        (click)="openModal(tab)"
                        class="cursor-pointer ml-5">location_on</mat-icon>
                      }
                    </div>
                  </ng-template>

                  <ng-template matTabContent>
                    <div class=" pb-15 overflow-auto h-full" style="max-height: calc(100vh - 250px);">
                      @switch (tab.id) {
                      @case(TabsIds.UNATTENDED_ORDERS){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="unattendedOrdersTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      @case(TabsIds.ORDERS_WITHOUT_DELIVERY_ROUTE){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="ordersWithoutDeliveryRouteTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      @case(TabsIds.ORDERS_WITHOUT_DELIVERY_DATE){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="ordersWithoutDeliveryDateTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      @case(TabsIds.ORDERS_WITHOUT_LOAD_DATE){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="ordersWithoutLoadDateTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      @case(TabsIds.ORDERS_WITHOUT_TRIP){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="ordersWithoutTripTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      @case(TabsIds.ORDERS_WITH_ROUTE_AND_TRIP){
                      @if (isLoading) {
                      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
                      }
                      @else {
                      <ng-container *ngTemplateOutlet="ordersWithRouteAndTripTab; 
                              context: { $implicit: tab }">
                      </ng-container>
                      }
                      }
                      }
                    </div>
                  </ng-template>
                </mat-tab>
                }
              </mat-tab-group>
            </div>

          </div>
        </div>
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator [disabled]="groupTabConfig.tabs[selectedTabIndex()]?.total() <= 0" class="z-10"
            [pageSizeOptions]="[2,50, 100, 150, 200]" showFirstLastButtons
            [length]="groupTabConfig.tabs[selectedTabIndex()]?.total() || 0"
            [pageIndex]="groupTabConfig.tabs[selectedTabIndex()]?.pagination().pageIndex || 0"
            [pageSize]="groupTabConfig.tabs[selectedTabIndex()]?.pagination().pageSize || 50"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
    <div [formGroup]="filterForm">
      <app-filter-section title="Rango de fechas" [expanded]="true">
        <app-dates-filters [form]="filterForm" [showUploadDate]="true" />
      </app-filter-section>

      <app-filter-section title="Configuración" [expanded]="true">
        <app-configuration-filters
          [form]="filterForm"
          [companyWithMongoId]="companyFilterUseMongoId"
          [officeGroupByMongoId]="true"
          [salesOffice]="true"
        ></app-configuration-filters>
      </app-filter-section>

      <app-filter-section title="Documentos" [expanded]="false">
        <app-documents-filters
        [form]="filterForm"
        [documentClass]="true"
        [typeDocumentClass]="'DT002'"
        ></app-documents-filters>
      </app-filter-section>

      <app-filter-section title="Gestión de Rutas" [expanded]="false">

        <app-routes-filters
        [form]="filterForm"
        [territory]="true"
        [areaRoute]="true"
        [routeGroup]="true"
        [route]="true"
      ></app-routes-filters>
      </app-filter-section>

      <app-filter-section title="Socio de negocios" [expanded]="false">
        <app-business-partners-filters
          [form]="filterForm"
          [businessPartner]="true"
        ></app-business-partners-filters>
      </app-filter-section>
    </div>
  </app-filter>
</mat-sidenav-container>




<ng-template #noDataTemplate>
  <div class="p-8 text-center text-xl sm:p-10">
    Lo sentimos, no hay registros para mostrar.
  </div>
  <pre>{{index}} - {{filterForm.value | json}}</pre>
</ng-template>

<!-- IlOading template -->
<ng-template #loadingTemplate>
  <div class="flex flex-row items-center justify-center">
    <mat-spinner diameter="32"></mat-spinner>
    <span class="ml-2">Cargando...</span>
  </div>
</ng-template>



<ng-template #unattendedOrdersTab let-tab>
  <app-order-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive" [canJoin]="false" [canCancel]="true"
    [documentClasses]="groupTabConfig.documentClasses()"></app-order-table>
</ng-template>

<ng-template #ordersWithoutDeliveryRouteTab let-tab>
  <app-order-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive" [canUnifyConditions]="false"
    (ordersJoined)="getOrdersWithoutRoute()" [documentClasses]="groupTabConfig.documentClasses()"></app-order-table>
</ng-template>

<ng-template #ordersWithoutDeliveryDateTab let-tab>
  <app-order-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive"
    [documentClasses]="groupTabConfig.documentClasses()"></app-order-table>
</ng-template>

<ng-template #ordersWithoutLoadDateTab let-tab>
  <app-order-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive"
    [documentClasses]="groupTabConfig.documentClasses()"></app-order-table>
</ng-template>

<ng-template #ordersWithoutTripTab let-tab>
  <app-order-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive" [canUnifyConditions]="false"
    [documentClasses]="groupTabConfig.documentClasses()"></app-order-table>
</ng-template>

<ng-template #ordersWithRouteAndTripTab let-tab>
  <app-trip-table [ordersData]="groupTabConfig.tabs[selectedTabIndex()].data()" (onSortChange)="changeSort($event)"
    [displayedColumns]="groupTabConfig.tabs[selectedTabIndex()].displayedColumns()"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive" [canUnifyConditions]="false"  [userMap]="true"
    [documentClasses]="groupTabConfig.documentClasses()" (ordersJoined)="getOrdersWithRouteAndTrip()"></app-trip-table>
</ng-template>